import React, { useState, useContext, useCallback } from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';

import { Context } from '@store/store';

const PageFrame = ({ pageFrameTags, bookId }) => {
  const [state, dispatch] = useContext(Context);
  const [mobileScale, setMobileScale] = useState(0);
  const [pageFrameDimensions, setPageFrameDimensions] = useState({
    width: 0,
    height: 0,
  });

  const inlineWidthAndHeightToPfOptions = {
    replace: node => {
      if (
        node.attribs &&
        node.name === 'div' &&
        node.attribs.id?.startsWith('pf')
      ) {
        const props = attributesToProps(node.attribs);
        return (
          <div
            {...props}
            style={{
              width: `${pageFrameDimensions.width}px`,
              height: `${pageFrameDimensions.height}px`,
            }}
          >
            {domToReact(node.children, inlineScaleToPcOptions)}
          </div>
        );
      }
    },
  };

  const inlineScaleToPcOptions = {
    replace: node => {
      if (
        node.attribs &&
        node.name === 'div' &&
        node.attribs.class.startsWith('pc')
      ) {
        const props = attributesToProps(node.attribs);
        return (
          <div
            {...props}
            ref={measuredRef}
            style={{ transform: `scale(${mobileScale})` }}
          >
            {domToReact(node.children, replaceImageSrcOptions)}
          </div>
        );
      }
    },
  };

  const replaceImageSrcOptions = {
    replace: node => {
      if (node.attribs && node.name === 'img') {
        const src = node.attribs.src;
        let modifiedSrc = process.env.REACT_APP_ONLINE2_VIEW_URL + `${bookId}/` + src;
        if (state.efedNoAuth ?? null) {
          modifiedSrc = modifiedSrc.replace("/online2/", "/efed/");
        }
        const props = attributesToProps(node.attribs);
        const modProps = { ...props, src: modifiedSrc };
        return <img {...modProps} />;
      }
    },
  };

  const measuredRef = useCallback(node => {
    if (node !== null) {
      const pageCSSWidth = parseFloat(getComputedStyle(node).width);
      const pageCSSHeight = parseFloat(getComputedStyle(node).height);
      const _mobileScale = state.wv / pageCSSWidth;
      setMobileScale(_mobileScale);
      setPageFrameDimensions({
        width: pageCSSWidth * _mobileScale,
        height: pageCSSHeight * _mobileScale,
      });
      dispatch({ type: 'ZOOM_IN_OUT', payload: _mobileScale });
    }
  }, []);

  return (
    <React.Fragment>
      {parse(pageFrameTags, inlineWidthAndHeightToPfOptions)}
    </React.Fragment>
  );
};

export default PageFrame;
